import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { ProductService } from 'src/app/shared/_service/product.service';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { Subject } from 'rxjs';
import { Config } from 'datatables.net-dt';

@Component({
	selector: 'app-tracking',
	templateUrl: './tracking.component.html',
})
export class TrackingComponent implements OnInit, OnDestroy, AfterViewInit {
	constructor(
		private api: ApiService,
		private modalService: NgbModal,
		private auth: AuthService,
	) {}

	@ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;
	@ViewChild('header', { static: false }) header: ElementRef;

	dtOptions: Config = { pageLength: 50 };
	dtTrigger: Subject<any> = new Subject<any>();

	righeOrdine = [];

	righeOrdineTotali = [];

	rigaSelected;

	filter = null;

	filtroAnno: number = new Date().getFullYear();
	anni = [];

	isAdminOrBackoffice = false;

	ngOnInit() {
		this.isAdminOrBackoffice = this.auth.isAdminOrBackoffice;
		for (let i = new Date().getFullYear(); i >= 2021; i--) {
			this.anni.push(i);
		}
		this.aggiornaTracking();
	}

	ngAfterViewInit() {}

	aggiornaTracking() {
		const table = $('#dt');
		table.DataTable().destroy(); // Distruggi l'istanza della DataTable
		this.righeOrdine = [];
		this.righeOrdineTotali = [];

		this.api.getOrdiniFiltrati(this.filtroAnno, undefined).subscribe((res) => {
			const ordini = res.sort((a, b) => b.dataRegistrazioneOrdine - a.dataRegistrazioneOrdine).filter((o) => o.prodottiCarrello.length > 0);

			ordini.forEach((o) => {
				o.prodottiCarrello.forEach((pc) => {
					pc.nOrdine = o.id;
					pc.rifOrdineCliente = o.rifOrdineCliente;
					pc.utente = o.utente;
				});

				o.prodottiCarrello = o.prodottiCarrello.sort((pc1, pc2) => pc1.progressivoRiga - pc2.progressivoRiga);
			});

			this.righeOrdineTotali = ordini.map((o) => [...o.prodottiCarrello]).flat();
			this.righeOrdine = ordini.map((o) => [...o.prodottiCarrello]).flat();

			this.righeOrdine.forEach((ro) => {
				switch (ro.statoRigaOrdine) {
					case 'RECEIVED':
						ro.progressivoStato = 1;
						break;
					case 'CONFIRMED':
						ro.progressivoStato = 2;
						break;
					case 'PLANNED':
						ro.progressivoStato = 3;
						break;
					case 'IN_PRODUCTION':
						ro.progressivoStato = 4;
						break;
					case 'QUALITY_CONTROL':
						ro.progressivoStato = 5;
						break;
					case 'IN_STOCK':
						ro.progressivoStato = 6;
						break;
					case 'IN_SHIPMENT':
						ro.progressivoStato = 7;
						break;
					case 'PARTIALLY_SHIPPED':
						ro.progressivoStato = 8;
						break;
					case 'SHIPPED':
						ro.progressivoStato = 9;
						break;
				}
			});
			this.dtOptions = { pageLength: 50 };
			this.dtTrigger = new Subject();
			setTimeout(() => {
				this.dtTrigger.next();
			}, 150);
		});
	}

	open(content, riga) {
		this.rigaSelected = riga;
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(() => {});
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	filtra(progressivoStato) {
		if (progressivoStato === this.filter) {
			this.filter = null;
			this.righeOrdine = this.righeOrdineTotali;
			this.dtTrigger.next();
			return;
		} else {
			this.filter = progressivoStato;

			if (progressivoStato > 2 && progressivoStato < 6) {
				this.righeOrdine = this.righeOrdineTotali.filter((r) => r.dataSpedizionePrevista);
			} else {
				this.righeOrdine = this.righeOrdineTotali.filter((r) => r.progressivoStato === progressivoStato);
			}

			this.dtTrigger.next();
		}
	}

	export(openOrder) {
		this.api.getExcelTracking({ codice_lingua: 'us', openOrder }).subscribe((blob) => {
			const URL = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.href = URL;
			a.download = 'Bertazzoni Tracking Export.xlsx';
			a.click();
			window.URL.revokeObjectURL(URL);
			a.remove();
		});
	}

	filtraCliente(event) {
		this.datatableElement.dtInstance.then((dtInstance: any) => {
			dtInstance.columns(0).search(event.target.value).draw();
		});
	}
}
